// Headroom: http://wicky.nillia.ms/headroom.js/
import Headroom from "headroom.js";

var nav = new Headroom(document.getElementById('navbar'), {
  offset: 100,
  tolerance: 10
});

nav.init();